import {useOutletContext} from "react-router-dom";

import {FormDirtyProvider} from "base/form/provider";
import {ViewPermitApplicationWidget} from ".";

const ViewPermitPaymentProcessSubPage = () => {
    const [permit] = useOutletContext();

    return permit ? (
        <FormDirtyProvider>
            <ViewPermitApplicationWidget permit={permit} process="payment" />
        </FormDirtyProvider>
    ) : null;
};

export default ViewPermitPaymentProcessSubPage;
